const WIDGET_ROUTE = '#widget'

exports.WIDGET_ROUTE = WIDGET_ROUTE
